
    const groupLabel = document.querySelector('.group_label');
    const group = document.querySelector('.filter-group');

    groupLabel.addEventListener('click', toggleTeamFilters);

//Toggle hamburger menu
    function toggleTeamFilters() {
        group.classList.toggle('hide-filters');
    }

// external js: isotope.pkgd.js

// init Isotope

    const iso = new Isotope('.logo-block', {
        itemSelector: '.item',
        layoutMode: 'fitRows',
        fitRows: {
            equalheight: true
        }
    });


// bind filter button click
    const filtersElem = document.querySelector('.filters-li-group');
    filtersElem.addEventListener('click', function (event) {
        // only work with li
        if (!matchesSelector(event.target, 'li')) {
            return;
        }

        // use matching filter function
        filterValue = event.target.getAttribute('data-filter');
        iso.arrange({filter: filterValue});
    });

// change is-checked class on buttons
    const buttonGroups = document.querySelectorAll('.filters-li-group');
    for (var i = 0, len = buttonGroups.length; i < len; i++) {
        var buttonGroup = buttonGroups[i];
        radioButtonGroup(buttonGroup);
    }

    function radioButtonGroup(buttonGroup) {
        buttonGroup.addEventListener('click', function (event) {
            // only work with buttons
            if (!matchesSelector(event.target, 'li')) {
                return;
            }
            buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
            event.target.classList.add('is-checked');
            document.getElementById('selected-filter').textContent = event.target.innerText;
            toggleTeamFilters();
            document.getElementById('filter-count').textContent = iso.filteredItems.length;
        });
    }

    document.getElementById('filter-count').textContent = iso.filteredItems.length;

    // Dirty hack to re init isotope after page is done loading to avoid overlapping divs.
    document.addEventListener("DOMContentLoaded", function() {
        const simulateClick = function (elem) {
            // Create our event (with options)
            const evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            // If cancelled, don't dispatch our event
            const canceled = !elem.dispatchEvent(evt);
        };
        const selected = document.querySelector('.is-checked');
        simulateClick(selected); // open filtermenu and click selected
        simulateClick(selected); // click again to close listbox...

    })